import { render, staticRenderFns } from "./tabInventory.vue?vue&type=template&id=0c00f197&scoped=true"
import script from "./tabInventory.vue?vue&type=script&lang=js"
export * from "./tabInventory.vue?vue&type=script&lang=js"
import style0 from "./tabInventory.vue?vue&type=style&index=0&id=0c00f197&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c00f197",
  null
  
)

export default component.exports